import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { isTokenExpired, COGNITO_CONFIG } from './api';
import OffersSection from './components/offers/OffersSection';
import FeaturedSection from './components/featured/FeaturedSection';
import BlogsSection from './components/blogs/BlogsSection';

function Admin() {
  const navigate = useNavigate();
  const [isAuthorized, setIsAuthorized] = useState(false);
  const [activeSection, setActiveSection] = useState('offers');
  const [visitedSections, setVisitedSections] = useState(['offers']);

  const handleSectionChange = (section) => {
    setActiveSection(section);
    setVisitedSections(prev => prev.includes(section) ? prev : [...prev, section]);
  };

  useEffect(() => {
    const isAdmin = localStorage.getItem('isAdmin');
    const accessToken = localStorage.getItem('accessToken');
    if (isAdmin === 'true' && accessToken && !isTokenExpired()) {
      setIsAuthorized(true);
    } else {
      localStorage.removeItem('isAdmin');
      localStorage.removeItem('accessToken');
      localStorage.removeItem('idToken');
      localStorage.removeItem('authCode');
      const cognitoUrl =
        `${COGNITO_CONFIG.DOMAIN}/login?client_id=${COGNITO_CONFIG.CLIENT_ID}` +
        `&response_type=code&scope=email+openid+phone&redirect_uri=${encodeURIComponent(COGNITO_CONFIG.REDIRECT_URI)}`;
      window.location.href = cognitoUrl;
    }
  }, [navigate]);

  const handleLogout = () => {
    localStorage.removeItem('isAdmin');
    localStorage.removeItem('authCode');
    localStorage.removeItem('accessToken');
    localStorage.removeItem('idToken');
    navigate('/');
  };

  if (!isAuthorized) {
    return (
      <div style={{ textAlign: 'center', marginTop: 100 }}>
        <h2>Checking authorization...</h2>
      </div>
    );
  }

  const sectionBtnStyle = (isActive) => ({
    flex: 1,
    padding: '14px 20px',
    borderRadius: 12,
    background: isActive ? 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)' : '#f1f5f9',
    color: isActive ? '#fff' : '#64748b',
    border: 'none',
    fontWeight: 700,
    cursor: 'pointer',
    fontSize: '0.95rem',
    transition: 'all 0.3s ease',
    boxShadow: isActive ? '0 4px 15px rgba(99, 102, 241, 0.4)' : 'none',
  });

  return (
    <div className="admin-panel">
      <div className="admin-panel-header">
        <h1>Admin Panel</h1>
        <div className="admin-panel-header-actions">
          <button onClick={() => navigate('/')} style={{ padding: '8px 18px', borderRadius: 8, background: '#eef2ff', color: '#6366f1', border: '2px solid #6366f1', fontWeight: 600, cursor: 'pointer' }}>
            Back to Gallery
          </button>
          <button onClick={handleLogout} style={{ padding: '8px 18px', borderRadius: 8, background: '#f43f5e', color: '#fff', border: 'none', fontWeight: 600, cursor: 'pointer' }}>
            Logout
          </button>
        </div>
      </div>

      {/* Section Navigation Tabs */}
      <div style={{ display: 'flex', gap: 12, marginBottom: 24, flexWrap: 'wrap' }}>
        <button onClick={() => handleSectionChange('offers')} style={sectionBtnStyle(activeSection === 'offers')}>
          🏷️ Offers
        </button>
        <button onClick={() => handleSectionChange('featured')} style={sectionBtnStyle(activeSection === 'featured')}>
          ⭐ Featured Offers
        </button>
        <button onClick={() => handleSectionChange('blogs')} style={sectionBtnStyle(activeSection === 'blogs')}>
          📝 Blogs
        </button>
      </div>

      {visitedSections.includes('offers') && (
        <div style={{ display: activeSection === 'offers' ? 'block' : 'none' }}>
          <OffersSection />
        </div>
      )}
      {visitedSections.includes('featured') && (
        <div style={{ display: activeSection === 'featured' ? 'block' : 'none' }}>
          <FeaturedSection />
        </div>
      )}
      {visitedSections.includes('blogs') && (
        <div style={{ display: activeSection === 'blogs' ? 'block' : 'none' }}>
          <BlogsSection />
        </div>
      )}
    </div>
  );
}

export default Admin;
